'use client';

import React, { useState } from 'react';

type MarkupSnippetProps = {
  code: string;
  label?: string;
  copyLabel?: string;
  copiedLabel?: string;
  className?: string;
};

const MarkupSnippet: React.FC<MarkupSnippetProps> = ({
  code,
  label = 'HTML',
  copyLabel = 'Copy',
  copiedLabel = 'Copied',
  className = '',
}) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    let didCopy = false;
    try {
      await navigator.clipboard.writeText(code);
      didCopy = true;
    } catch {
      const area = document.createElement('textarea');
      area.value = code;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.left = '-9999px';
      document.body.appendChild(area);
      area.select();
      didCopy = document.execCommand('copy');
      area.remove();
    }
    if (!didCopy) return;
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };

  return (
    <details className={`markup-snippet${className ? ` ${className}` : ''}`}>
      <summary>{label}</summary>
      <div className='markup-snippet-body'>
        <pre>
          <code>{code}</code>
        </pre>
        <button type='button' className='btn btn-ghost btn-sm' onClick={copy}>
          <span className='label'>{copied ? copiedLabel : copyLabel}</span>
        </button>
      </div>
    </details>
  );
};

export function markupCopyLabels(isSpanish: boolean) {
  return {
    label: 'HTML',
    copyLabel: isSpanish ? 'Copiar' : 'Copy',
    copiedLabel: isSpanish ? 'Copiado' : 'Copied',
  };
}

export default MarkupSnippet;
